// This file auto-registers all blog posts
import { registerBlogPost } from "@/lib/blog";
// Image imports removed in favor of static paths


// Manually register each blog post
// To add a new post, create the .mdx file in src/content/blog/ 
// and add an entry here

// English Posts
registerBlogPost({
  slug: "revisiting-team-building-in-2025",
  author: "Kevin Rassner",
  title: "Revisiting Team Building in 2025: Challenging Old Beliefs – What the Science Really Says",
  date: "2025-11-13",
  excerpt: "Which team building methods really work in 2025? Analysis of Herzberg, MBTI criticism, psychological safety, and AI's impact on modern teams.",
  metaTitle: "Team Building 2025: Old Beliefs vs. New Science | Kevin Rassner",
  metaDescription: "Which team building methods really work in 2025? Analysis of Herzberg, MBTI criticism, psychological safety, and AI's impact on modern teams.",
  language: "en",
  image: "/assets/blog/revisiting_team_building.png",
});

registerBlogPost({
  slug: "bottleneck-concentrated-strategy-global-perspective",
  title: "Bottleneck-concentrated strategy - a global perspective",
  date: "2018-06-04",
  excerpt: "An exploration of bottleneck-concentrated strategy in global management, examining the key-lock model, minimum law, and implications for organizations.",
  metaTitle: "Bottleneck-concentrated strategy - a global perspective - Rassner-Dev.Org",
  metaDescription: "Discover the principles behind bottleneck-concentrated strategy, its impact on global business management, and practical insights for organizational development.",
  language: "en",
  image: "/assets/blog/bottleneck-concentrated-strategy-a-global-perspective/bottleneck-concentrated-strategy-a-global-perspective.png",
});

registerBlogPost({
  slug: "the-three-biggest-part-time-lies",
  title: "The three biggest part-time lies",
  date: "2018-06-18",
  excerpt: "An analysis of part-time work myths, focusing on the German labour market, its impact on gender roles, and what needs to change for true work-life freedom.",
  metaTitle: "The three biggest part-time lies - Rassner-Dev.Org",
  metaDescription: "Explore the three major misconceptions about part-time work, their impact on gender dynamics, and how changing perspectives can foster true freedom of choice.",
  language: "en",
  image: "/assets/blog/the-three-biggest-part-time-lies/the-three-biggest-part-time-lies.png",
});

registerBlogPost({
  slug: "y-tho-why-it-is-now-time-for-new-management-methods",
  title: "Y tho? Why it is now time for new management methods",
  date: "2018-05-10",
  excerpt: "A spotlight on why modern organizations must adopt new management methods  -  examining the human factor, the evolution of technology, and Generation Y's impact on the business landscape.",
  metaTitle: "Y tho? Why it is now time for new management methods - Rassner-Dev.Org",
  metaDescription: "Explore why organizations should move toward modern management methods; the importance of people, technology trends, and how Generation Y is shaping the workplace.",
  language: "en",
  image: "/assets/blog/y-tho-why-it-is-now-time-for-new-management-methods/y-tho-why-it-is-now-time-for-new-management-methods.png",
});

registerBlogPost({
  slug: "why-alexa-couldnt-help-me-find-a-more-creative-title",
  title: "Why Alexa couldn't help me find a more creative title",
  date: "2018-04-14",
  excerpt: "Why creativity beats automation, and how leaders and organizations can intentionally create room for more creative breakthroughs at work. Learn which human qualities foster new ideas and practical strategies to boost team creativity.",
  metaTitle: "Why Alexa Couldn't Help Me Find a More Creative Title - Rassner-Dev.Org",
  metaDescription: "Explore the limits of digital automation and discover proven techniques for nurturing creativity in yourself and your organization.",
  language: "en",
  image: "/assets/blog/why-alexa-couldn-t-help-me-find-a-more-creative-title/why-alexa-couldn-t-help-me-find-a-more-creative-title.png",
});

// German Posts
registerBlogPost({
  slug: "team-building-2025-neubewertung",
  title: "Team Building 2025: Meine alten Überzeugungen hinterfragen – Was die Wissenschaft wirklich sagt",
  date: "2025-11-13",
  excerpt: "Welche Team-Building-Methoden funktionieren 2025 wirklich? Analyse von Herzberg, MBTI-Kritik, psychologischer Sicherheit und KI-Einfluss auf moderne Teams.",
  metaTitle: "Team Building 2025: Alte Überzeugungen vs. neue Wissenschaft | Kevin Rassner",
  metaDescription: "Welche Team-Building-Methoden funktionieren 2025 wirklich? Analyse von Herzberg, MBTI-Kritik, psychologischer Sicherheit und KI-Einfluss auf moderne Teams.",
  language: "de",
});

registerBlogPost({
  slug: "engpasskonzentrierte-strategie-globale-perspektive",
  title: "Engpasskonzentrierte Strategie, eine globale Perspektive",
  date: "2018-06-04",
  excerpt: "Eine strategische Perspektive basierend auf dem Prinzip des Kundennutzens und der Engpasskonzentrierung. Vom Schlüssel-Schloss-Prinzip über das Minimumgesetz bis zu globalen Systemfragen.",
  metaTitle: "Engpasskonzentrierte Strategie - Globale Perspektive | Rassner-Dev.Org",
  metaDescription: "Erfahren Sie, wie die Engpasskonzentrierte Strategie nach Wolfgang Mewes Unternehmen erfolgreicher macht und welche Rolle Kundenbedürfnisse und Innovationskraft spielen.",
  language: "de",
  image: "/assets/blog/bottleneck-concentrated-strategy-a-global-perspective/bottleneck-concentrated-strategy-a-global-perspective.png",
});

registerBlogPost({
  slug: "die-drei-groessten-teilzeitluegen",
  title: "Die drei größten Teilzeitlügen",
  date: "2018-06-18",
  excerpt: "Warum viele Annahmen rund um Teilzeit falsch sind und echte Wahlfreiheit dringend eine neue Perspektive auf Arbeit braucht.",
  metaTitle: "Die drei größten Teilzeitlügen - Rassner-Dev.Org",
  metaDescription: "Dieser Artikel von Kevin Rassner deckt die größten Mythen rund um Teilzeitarbeit auf und diskutiert die gesellschaftlichen Folgen sowie Lösungsansätze für mehr Wahlfreiheit.",
  language: "de",
  image: "/assets/blog/die-drei-groessten-teilzeitluegen/die-drei-groessten-teilzeitluegen.png",
});

registerBlogPost({
  slug: "warum-elon-musk-kein-hoehlenretter-wurde",
  title: "Warum Elon Musk kein Höhlenretter wurde",
  date: "2018-07-17",
  excerpt: "Eine Reflexion über Führung in turbulenten Zeiten, die Bedeutung menschlicher Qualitäten, Teambuilding am Beispiel des chilenischen Minenunglücks – und was Elon Musk daraus hätte lernen können.",
  metaTitle: "Warum Elon Musk kein Höhlenretter wurde - Rassner-Dev.Org",
  metaDescription: "Warum menschliche Qualitäten bei Führung in Turbulenzen wichtiger sind als Expertenwissen – Lektionen aus Katastrophenfällen, Business-Teamdynamik und Elon Musks Thailand-Einsatz.",
  language: "de",
  image: "/assets/blog/warum-elon-musk-kein-h%C3%B6hlenretter-wurde/warum-elon-musk-kein-h%C3%B6hlenretter-wurde.png",
});

registerBlogPost({
  slug: "y-tho-warum-es-zeit-fuer-neue-management-methoden-ist",
  title: "Y tho? Warum es jetzt Zeit für neue Management-Methoden ist",
  date: "2018-05-10",
  excerpt: "Warum innovative Management-Methoden heute relevanter sind denn je. Ein Schlaglicht auf die Veränderungen in Unternehmen, den Faktor Mensch und die Herausforderungen moderner Führung.",
  metaTitle: "Neue Management-Methoden – Warum heute Umdenken gefragt ist",
  metaDescription: "Erfahren Sie, warum moderne Unternehmen und Manager neue Wege gehen müssen, um im globalen Wettbewerb zu bestehen – mit Fokus auf Mensch, Generation Y und agile Methoden.",
  language: "de",
  image: "/assets/blog/y-tho-why-it-is-now-time-for-new-management-methods/y-tho-why-it-is-now-time-for-new-management-methods.png",
});

registerBlogPost({
  slug: "selbsterkenntnis-teambuilding",
  title: "You can't spell Team without me - Selbsterkenntnis als Schlüssel zum Teambuilding",
  date: "2018-03-11",
  excerpt: "Selbsterkenntnis ist der Schlüssel zum erfolgreichen Teambuilding. Warum echte Teams mehr sind als Gruppen und welche Rolle Vertrauen, Motivation und Persönlichkeitsmodelle im Aufbau eines Teams spielen.",
  metaTitle: "Selbsterkenntnis im Teambuilding - Rassner-Dev.Org",
  metaDescription: "Warum Selbsterkenntnis und Vertrauen zentrale Faktoren für Teambuilding sind – ein Praxisartikel von Kevin Rassner über Teams, Motivation und Persönlichkeitsmodelle.",
  language: "de",
  image: "/assets/blog/you-can-t-spell-team-without-me-selbsterkenntnis-als-schluessel-zum-teambuilding/you-can-t-spell-team-without-me-selbsterkenntnis-als-schluessel-zum-teambuilding.png",
});

registerBlogPost({
  slug: "warum-alexa-mir-nicht-bei-einem-kreativeren-titel-helfen-konnte",
  title: "Warum Alexa mir nicht bei einem kreativeren Titel helfen konnte",
  date: "2018-04-14",
  excerpt: "Warum Kreativität Automatisierung übertrifft und wie Führungskräfte und Organisationen bewusst Raum für kreative Durchbrüche schaffen können. Erfahren Sie, welche menschlichen Qualitäten neue Ideen fördern und welche praktischen Strategien die Kreativität im Team steigern.",
  metaTitle: "Warum Alexa mir nicht bei einem kreativeren Titel helfen konnte - Rassner-Dev.Org",
  metaDescription: "Entdecken Sie die Grenzen der digitalen Automatisierung und erproben Sie bewährte Techniken zur Förderung von Kreativität in sich selbst und Ihrer Organisation.",
  language: "de",
  image: "/assets/blog/why-alexa-couldn-t-help-me-find-a-more-creative-title/why-alexa-couldn-t-help-me-find-a-more-creative-title.png",
});

registerBlogPost({
  slug: "was-uns-oezil-ueber-diversitaet-lehrt",
  title: "Was uns Özil über Diversität lehrt",
  date: "2018-08-04",
  excerpt: "Die Debatte um Mesut Özil wirft zentrale Fragen über Diversität, Inklusion und unser Verständnis von Gerechtigkeit auf. Warum Vielfalt mehr als Geschlecht und Herkunft bedeutet und welche Implikationen das auf Unternehmensebene hat.",
  metaTitle: "Was uns Özil über Diversität lehrt - Rassner-Dev.Org",
  metaDescription: "Ein Blick auf Diversität und Inklusion, inspiriert vom Fall Mesut Özil. Wie definieren wir Vielfalt wirklich und welche Rolle spielen Unternehmen bei diesem gesellschaftlichen Wandel?",
  language: "de",
  image: "/assets/blog/was-uns-%C3%B6zil-%C3%BCber-diversit%C3%A4t-lehrt/was-uns-%C3%B6zil-%C3%BCber-diversit%C3%A4t-lehrt.png",
});

registerBlogPost({
  slug: "what-ozil-teaches-us-about-diversity",
  title: "What Özil teaches us about diversity",
  date: "2018-08-04",
  excerpt: "Lessons from the Özil case on true diversity, inclusion, and the dangers of selective empathy in organizations and society.",
  metaTitle: "What Özil teaches us about diversity - Rassner-Dev.Org",
  metaDescription: "Discover what the Özil case reveals about diversity in society and business, and why true inclusion matters more than regulations.",
  language: "en",
  image: "/assets/blog/what-%C3%B6zil-teaches-us-about-diversity/what-%C3%B6zil-teaches-us-about-diversity.png",
});

registerBlogPost({
  slug: "creative-workshop-night-at-the-museum",
  title: "Creative Workshop: Night at the Museum",
  date: "2018-09-15",
  excerpt: "An innovative approach to creative thinking and team building through an interactive museum experience.",
  metaTitle: "Creative Workshop: Night at the Museum - Rassner-Dev.Org",
  metaDescription: "Explore how our creative workshop transforms museum visits into powerful team-building and innovation experiences.",
  language: "en",
  image: "/assets/blog/creative-workshop-night-at-the-museum/creative-workshop-night-at-the-museum.png",
});

registerBlogPost({
  slug: "die-trust-economy",
  title: "Die Trust Economy",
  date: "2018-10-05",
  excerpt: "Wie Vertrauen zur wertvollsten Währung in der modernen Wirtschaft wird und warum Unternehmen darauf setzen sollten.",
  metaTitle: "Die Trust Economy - Warum Vertrauen die neue Währung ist - Rassner-Dev.Org",
  metaDescription: "Entdecken Sie, warum Vertrauen in der modernen Wirtschaft so wichtig ist und wie Unternehmen davon profitieren können.",
  language: "de",
  image: "/assets/blog/the-trust-economy/the-trust-economy.png",
});

registerBlogPost({
  slug: "the-trust-economy",
  title: "The Trust Economy",
  date: "2018-10-05",
  excerpt: "How trust becomes the most valuable currency in the modern economy and why companies should invest in it.",
  metaTitle: "The Trust Economy - Why Trust is the New Currency - Rassner-Dev.Org",
  metaDescription: "Discover why trust is becoming the most important currency in modern business and how companies can benefit from it.",
  language: "en",
  image: "/assets/blog/the-trust-economy/the-trust-economy.png",
});

registerBlogPost({
  slug: "die-umkehrung-der-hierarchiepyramide",
  title: "Die Umkehrung der Hierarchiepyramide",
  date: "2018-10-20",
  excerpt: "Warum traditionelle Hierarchien in modernen Unternehmen nicht mehr funktionieren und was die bessere Alternative ist.",
  metaTitle: "Die Umkehrung der Hierarchiepyramide - Neue Wege der Unternehmensführung - Rassner-Dev.Org",
  metaDescription: "Erfahren Sie, warum traditionelle Hierarchien ausgedient haben und wie moderne Unternehmen erfolgreicher führen können.",
  language: "de",
  image: "/assets/blog/die-umkehrung-der-hierarchiepyramide/die-umkehrung-der-hierarchiepyramide.png",
});

registerBlogPost({
  slug: "the-reversal-of-the-hierarchy-pyramid",
  title: "The Reversal of the Hierarchy Pyramid",
  date: "2018-10-20",
  excerpt: "Why traditional hierarchies don't work in modern companies and what the better alternative looks like.",
  metaTitle: "The Reversal of the Hierarchy Pyramid - New Ways of Leadership - Rassner-Dev.Org",
  metaDescription: "Learn why traditional hierarchies are becoming obsolete and how modern companies can lead more successfully.",
  language: "en",
  image: "/assets/blog/the-reversal-of-the-hierarchy-pyramid/the-reversal-of-the-hierarchy-pyramid.png",
});

registerBlogPost({
  slug: "gamification-als-werkzeug-des-modernen-managers",
  title: "Gamification als Werkzeug des modernen Managers",
  date: "2018-11-10",
  excerpt: "Wie spielerische Elemente die Mitarbeitermotivation und Produktivität steigern können.",
  metaTitle: "Gamification im Management - Spielend zum Erfolg - Rassner-Dev.Org",
  metaDescription: "Entdecken Sie, wie Sie mit Gamification Ihre Mitarbeiter motivieren und bessere Ergebnisse erzielen können.",
  language: "de",
  image: "/assets/blog/gamification-as-a-modern-manager-s-tool/gamification-as-a-modern-manager-s-tool.png",
});

registerBlogPost({
  slug: "gamification-as-a-modern-managers-tool",
  title: "Gamification as a Modern Manager's Tool",
  date: "2018-11-10",
  excerpt: "How game elements can boost employee motivation and productivity in the workplace.",
  metaTitle: "Gamification in Management - Succeed Through Play - Rassner-Dev.Org",
  metaDescription: "Discover how gamification can help you motivate employees and achieve better results in your organization.",
  language: "en",
  image: "/assets/blog/gamification-as-a-modern-manager-s-tool/gamification-as-a-modern-manager-s-tool.png",
});

registerBlogPost({
  slug: "instant-feedback-flughafentoiletten",
  title: "Instant Feedback - Was Manager von Flughafentoiletten lernen können",
  date: "2018-11-25",
  excerpt: "Überraschende Erkenntnisse aus dem Alltag, die das Feedback-Management in Unternehmen revolutionieren können.",
  metaTitle: "Instant Feedback - Lektionen aus dem Alltag für besseres Management - Rassner-Dev.Org",
  metaDescription: "Erfahren Sie, was Manager von alltäglichen Feedback-Systemen lernen können und wie Sie dies in Ihrem Unternehmen umsetzen.",
  language: "de",
  image: "/assets/blog/instant-feedback-what-managers-can-learn-from-airport-toilets/instant-feedback-what-managers-can-learn-from-airport-toilets.png",
});

registerBlogPost({
  slug: "instant-feedback-what-managers-can-learn-from-airport-toilets",
  title: "Instant Feedback - What Managers Can Learn from Airport Toilets",
  date: "2018-11-25",
  excerpt: "Surprising insights from everyday life that can revolutionize feedback management in organizations.",
  metaTitle: "Instant Feedback - Everyday Lessons for Better Management - Rassner-Dev.Org",
  metaDescription: "Discover what managers can learn from everyday feedback systems and how to implement these insights in your organization.",
  language: "en",
  image: "/assets/blog/instant-feedback-what-managers-can-learn-from-airport-toilets/instant-feedback-what-managers-can-learn-from-airport-toilets.png",
});

registerBlogPost({
  slug: "kreativ-workshop-nacht-im-museum",
  title: "Kreativ-Workshop: Nacht im Museum",
  date: "2018-09-15",
  excerpt: "Ein innovativer Ansatz für kreatives Denken und Teambuilding durch ein interaktives Museumserlebnis.",
  metaTitle: "Kreativ-Workshop: Nacht im Museum - Rassner-Dev.Org",
  metaDescription: "Erfahren Sie, wie unser Kreativ-Workshop Museumsbesuche in kraftvolle Teamerlebnisse verwandelt.",
  language: "de",
  image: "/assets/blog/kreativ-workshop-eine-nacht-im-museum/kreativ-workshop-eine-nacht-im-museum.png",
});

registerBlogPost({
  slug: "what-would-austin-powers-do-de",
  title: "What Would Austin Powers Do? - Deutsche Version",
  date: "2019-01-15",
  excerpt: "Ungewöhnliche Führungslektionen, die wir von Austin Powers lernen können.",
  metaTitle: "Leadership-Lektionen von Austin Powers - Deutsche Version - Rassner-Dev.Org",
  metaDescription: "Entdecken Sie überraschende Führungsprinzipien, inspiriert von Austin Powers.",
  language: "de",
  image: "/assets/blog/what-would-austin-powers-do/what-would-austin-powers-do.png",
});

registerBlogPost({
  slug: "what-would-austin-powers-do-en",
  title: "What Would Austin Powers Do?",
  date: "2019-01-15",
  excerpt: "Unconventional leadership lessons we can learn from Austin Powers.",
  metaTitle: "Leadership Lessons from Austin Powers - Rassner-Dev.Org",
  metaDescription: "Discover surprising leadership principles inspired by Austin Powers' unconventional approach.",
  language: "en",
  image: "/assets/blog/what-would-austin-powers-do-english/what-would-austin-powers-do-english.png",
});

registerBlogPost({
  slug: "why-elon-musk-did-not-become-a-cave-rescuer",
  title: "Why Elon Musk Did Not Become a Cave Rescuer",
  date: "2018-07-17",
  excerpt: "A reflection on leadership in turbulent times, the importance of human qualities, and team building through the lens of the Chilean mining accident - and what Elon Musk could have learned from it.",
  metaTitle: "Why Elon Musk Did Not Become a Cave Rescuer - Rassner-Dev.Org",
  metaDescription: "Why human qualities matter more than expertise in crisis leadership - lessons from disaster response, business team dynamics, and Elon Musk's Thailand cave mission.",
  language: "en",
  image: "/assets/blog/why-elon-musk-did-not-become-a-cave-rescuer/why-elon-musk-did-not-become-a-cave-rescuer.png",
});

registerBlogPost({
  slug: "you-cant-spell-team-without-me",
  title: "You Can't Spell Team Without Me",
  date: "2018-03-11",
  excerpt: "Self-awareness as the key to successful team building. Why real teams are more than just groups and the role of trust, motivation, and personality models in building effective teams.",
  metaTitle: "Self-Awareness in Team Building - Rassner-Dev.Org",
  metaDescription: "Why self-awareness and trust are central factors in team building - a practical article about teams, motivation, and personality models.",
  language: "en",
  image: "/assets/blog/you-can-t-spell-team-without-me/you-can-t-spell-team-without-me.png",
});

// LinkedIn Posts
registerBlogPost({
  slug: "organisationsentwicklung-1",
  title: "The Octopus Organization",
  date: "2025-11-21",
  excerpt: "Neues aus der Welt der Organisationsentwicklung - Im neuesten Buch diskutieren Jana Werner und Phil Le-Brun die 'Octopus Organization' als Gegenmodell zu klassischen Managementlogiken.",
  metaTitle: "Octopus Organization - Neues aus der Organisationsentwicklung | Kevin Rassner",
  metaDescription: "Jana Werner und Phil Le-Brun diskutieren die 'Octopus Organization' als innovatives Gegenmodell zu klassischen Managementlogiken. Erfahren Sie, wie Organisationen Vertrauen und dezentrale Entscheidungsfreiheit als Erfolgsfaktoren verankern können.",
  language: "de",
  linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7397536786501193728/",
  isLinkedInPost: true,
  image: "/assets/blog/organisationsentwicklung_1.png",
});

registerBlogPost({
  slug: "leadership-as-team-sport",
  title: "Leadership as a Team Sport",
  date: "2025-11-20",
  excerpt: "Recent research from Harvard Business Review reveals that only about 31% of C-suite executives truly see each other as a team. Team coaching can transform executive collaboration.",
  metaTitle: "Leadership as a Team Sport - Executive Team Coaching | Kevin Rassner",
  metaDescription: "Discover why only 31% of C-suite executives see each other as a team and how team coaching can transform executive collaboration, decision-making, and organizational results.",
  language: "en",
  linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7397328307509420032/",
  isLinkedInPost: true,
});

registerBlogPost({
  slug: "my-first-sudoku",
  title: "My First Self-Created Sudoku",
  date: "2025-09-23",
  excerpt: "First day of vacation and after bingewatching CrackingTheCryptic on YouTube, I created a basketball-themed sudoku puzzle. Can you guess the sports team?",
  metaTitle: "My First Basketball-Themed Sudoku Puzzle | Kevin Rassner",
  metaDescription: "A custom basketball-themed sudoku puzzle inspired by CrackingTheCryptic. Test your puzzle-solving skills and see if you can guess the sports team without solving!",
  language: "en",
  linkedinUrl: "https://www.linkedin.com/posts/kevin-rassner_guess-the-sports-team-by-kevinrassner-svens-activity-7368560904738676736-EoAD?utm_source=share&utm_medium=member_desktop&rcm=ACoAABOVTMUBYXTIxIvCDnvaQZ6lrRF9KkXF3WM",
  isLinkedInPost: true,
});

registerBlogPost({
  slug: "titanic-culture-5",
  title: 'Titanic Culture (5/5): Only I Can Fix It',
  date: "2025-08-15",
  excerpt: 'The political manifestation of Titanic Culture - exploring how "Only I can fix it" leadership is reshaping politics and potentially business leadership.',
  metaTitle: "Titanic Culture Part 5 - Political Manifestation of Hero Leadership | Kevin Rassner",
  metaDescription: 'Explore how "Only I can fix it" leadership manifests in politics with Trump, Milei, and Bolsonaro, and what this means for the future of business leadership and organizational culture.',
  language: "en",
  linkedinUrl: "https://www.linkedin.com/posts/kevin-rassner_only-i-can-fix-it-the-political-manifestation-activity-7355858400544489473-5mQg?utm_source=share&utm_medium=member_desktop&rcm=ACoAABOVTMUBYXTIxIvCDnvaQZ6lrRF9KkXF3WM",
  isLinkedInPost: true,
  image: "/assets/blog/titanic-5.jpg",
});

registerBlogPost({
  slug: "titanic-culture-4",
  title: 'Titanic Culture (4/5): Orbiting the Star',
  date: "2025-08-10",
  excerpt: "In Titanic Culture organizations, traditional roles lose meaning as expertise matters less than the ability to amplify the hero's vision. You don't explore the universe - you orbit around the star.",
  metaTitle: "Titanic Culture Part 4 - How Hero Culture Transforms Professional Roles | Kevin Rassner",
  metaDescription: "Discover how Titanic Culture fundamentally transforms professional roles, where competence becomes secondary to proximity to power and being aligned matters more than being right.",
  language: "en",
  linkedinUrl: "https://www.linkedin.com/posts/kevin-rassner_workplacedynamics-careerstrategy-leadership-activity-7354405119402147840-8GRP?utm_source=share&utm_medium=member_desktop&rcm=ACoAABOVTMUBYXTIxIvCDnvaQZ6lrRF9KkXF3WM",
  isLinkedInPost: true,
  image: "/assets/blog/titanic-4.jpg",
});

registerBlogPost({
  slug: "titanic-culture-3",
  title: 'Titanic Culture (3/5): Reputation Over Rigor',
  date: "2025-08-05",
  excerpt: "How expertise itself is being redefined in the age of Titanic Culture, where visibility matters more than depth and influence trumps insight.",
  metaTitle: "Titanic Culture Part 3 - Reputation Over Rigor in Modern Expertise | Kevin Rassner",
  metaDescription: "Explore how Titanic Culture redefines expertise, where the visibility-first economy rewards simplification over nuance and personal narratives over collaborative achievements.",
  language: "en",
  linkedinUrl: "https://www.linkedin.com/posts/kevin-rassner_reputation-over-rigor-how-expertise-activity-7353319140096417794-Itd6?utm_source=share&utm_medium=member_desktop&rcm=ACoAABOVTMUBYXTIxIvCDnvaQZ6lrRF9KkXF3WM",
  isLinkedInPost: true,
  image: "/assets/blog/titanic-3.jpg",
});

registerBlogPost({
  slug: "titanic-culture-2",
  title: 'Titanic Culture (2/5): The $100M Hero Bet',
  date: "2025-07-28",
  excerpt: "Meta's $100M AI signing bonuses reveal a fundamental shift from building robust teams to betting on individual heroes who will solve complex challenges single-handedly.",
  metaTitle: "Titanic Culture Part 2 - Meta's $100M AI Talent Strategy | Kevin Rassner",
  metaDescription: "Analyze how Meta's $100M AI signing bonuses illustrate the shift from collaborative intelligence to individual genius, and what this means for innovation and talent strategy.",
  language: "en",
  linkedinUrl: "https://www.linkedin.com/posts/kevin-rassner_innovation-talentstrategy-ai-activity-7351869085325926401-hxVH?utm_source=share&utm_medium=member_desktop&rcm=ACoAABOVTMUBYXTIxIvCDnvaQZ6lrRF9KkXF3WM",
  isLinkedInPost: true,
  image: "/assets/blog/titanic-2.jpg",
});

registerBlogPost({
  slug: "titanic-culture-1",
  author: "Kevin Rassner",
  title: 'Titanic Culture (1/5): A New Cultural Logic',
  date: "2025-07-28",
  excerpt: "Is there a new cultural logic emerging in business? Exploring the rise of Titanic Culture - where leaders position themselves as singular saviors who alone can fix complex systems.",
  metaTitle: "Titanic Culture Part 1 - The Rise of Mythic Individualism in Business | Kevin Rassner",
  metaDescription: "Discover Titanic Culture, an emerging eighth cultural paradigm where mythic individualism and visionary dominance transform how we understand leadership and organizational behavior.",
  language: "en",
  linkedinUrl: "https://www.linkedin.com/posts/kevin-rassner_leadership-businessculture-organizationaldevelopment-activity-7351236623335890944-bsh2?utm_source=share&utm_medium=member_desktop&rcm=ACoAABOVTMUBYXTIxIvCDnvaQZ6lrRF9KkXF3WM",
  isLinkedInPost: true,
  image: "/assets/blog/titanic-1.jpg",
});

registerBlogPost({
  slug: "the-professionalism-trap-why-growing-up-shouldnt-mean-selling-out",
  author: "Kevin Rassner",
  title: "The Professionalism Trap: Why \"Growing Up\" Shouldn't Mean Selling Out",
  date: "2025-11-30",
  excerpt: "Entrepreneurs start businesses seeking freedom, but growth pressures them to replace free choices with corporate professionalism. This article explores why this \"growing up\" is a trap and how startups can choose greatness over soulless bureaucracy while remaining successful.",
  metaTitle: "The Professionalism Trap: Why \"Growing Up\" Shouldn't Mean Selling Out",
  metaDescription: "Entrepreneurs start businesses seeking freedom, but growth pressures them to replace free choices with corporate professionalism. This article explores why this \"growing up\" is a trap and how startups can choose greatness over soulless bureaucracy while remaining successful.",
  language: "en",
});

// LinkedIn Posts from CSV
registerBlogPost({
  slug: "resist-the-beginnings",
  title: "Resist the beginnings",
  date: "2025-06-13",
  excerpt: "As a German student in 2016/17 studying in the U.S., I remember a vivid conversation with one of our American professors at the University of West Florida. We were discussing the rise of Donald Trump during the presidential campaign.",
  metaTitle: "Resist the beginnings - Lessons from History | Kevin Rassner",
  metaDescription: "Reflecting on a conversation about the rise of Donald Trump and the warning signs of authoritarianism from a German perspective. 'Wehret den Anfängen' - Resist the beginnings.",
  language: "en",
  linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7339163077927428096",
  isLinkedInPost: true,
});

registerBlogPost({
  slug: "criticized-musks-leadership-seven-years-ago",
  title: "I criticized Musk's leadership seven years ago - nothing has changed",
  date: "2025-06-04",
  excerpt: "In 2018, I wrote a LinkedIn article examining Elon Musk's leadership failures during catastrophic times. Looking back at his gig to consult/lead the Department of Governmental Efficiency under Trump, I'm struck by how little has evolved in his approach.",
  metaTitle: "Musk's Leadership: Seven Years Later | Kevin Rassner",
  metaDescription: "Analyzing Elon Musk's leadership style from the Thai cave rescue to the Department of Governmental Efficiency. Has his approach evolved? The evidence suggests not.",
  language: "en",
  linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7336017044347256832",
  image: "/assets/blog/criticized-musks-leadership-seven-years-ago.jpg",
  isLinkedInPost: true,
});

registerBlogPost({
  slug: "public-transport-company-adapt-new-vision-part-5",
  title: "How Can a Public Transport Company Adapt to a New Vision? – Part 5",
  date: "2025-03-25",
  excerpt: "Change is inevitable - but how organizations respond makes all the difference. In our ongoing series, we explore fictional case studies to illustrate how companies can navigate transformation using systemic organizational development.",
  metaTitle: "Public Transport Adaptation - Systemic Organizational Development | Kevin Rassner",
  metaDescription: "Part 5 of the series on Systemic Organizational Development: How a public transport bus company can embrace a new vision and align teams and processes.",
  language: "en",
  linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7310291029239189504",
  isLinkedInPost: true,
});

registerBlogPost({
  slug: "angewandte-organisationsentwicklung-teil-4-supermarktkette",
  title: "Angewandte Organisationsentwicklung (Teil 4): Supermarktkette",
  date: "2025-03-20",
  excerpt: "In Teil 4 meiner Serie über angewandte Organisationsentwicklung betrachte ich eine große genossenschaftliche Supermarktkette und zeige hieran exemplarisch, wie sich Umstände und Ambitionen auf ideale Prozesse und Organisation durchschlagen.",
  metaTitle: "Organisationsentwicklung Teil 4: Supermarktkette | Kevin Rassner",
  metaDescription: "Teil 4 der Serie über angewandte Organisationsentwicklung: Analyse einer großen genossenschaftlichen Supermarktkette und deren Prozess- und Organisationsdesign.",
  language: "de",
  linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7308458603235999747",
  isLinkedInPost: true,
  tags: ["Organisationsentwicklung", "sowaswie", "edeka"],
});

registerBlogPost({
  slug: "angewandte-organisationsentwicklung-teil-3-kmu",
  author: "Kevin Rassner",
  title: "Angewandte Organisationsentwicklung (Teil 3): KMUs",
  date: "2025-03-18",
  excerpt: "In Teil 3 meiner Serie über angewandte Organisationsentwicklung tauchen wir erstmalig auf Deutsch tief in die Welt der KMUs ein. Ihr Erfolg hängt oft davon ab, wie sie ihre ganz individuellen Herausforderungen meistern.",
  metaTitle: "Organisationsentwicklung Teil 3: KMUs | Kevin Rassner",
  metaDescription: "Teil 3 der Serie über angewandte Organisationsentwicklung: Wie KMUs durch durchdachtes Prozess- und Organisationsdesign ihre individuellen Herausforderungen meistern.",
  language: "de",
  linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7307661727406444544",
  isLinkedInPost: true,
  tags: ["KMU", "Mittelstand", "Organisationsdesign", "Unternehmensentwicklung", "Erfolg", "Innovation"],
});

registerBlogPost({
  slug: "organizational-solutions-part-2-music-streaming",
  title: "Organizational Solutions Part 2: Music Streaming Service",
  date: "2025-03-14",
  excerpt: "#2 of of my series on how individual company circumstances demand unique organizational solutions. This time, we are looking at a music streaming service.",
  metaTitle: "Organizational Solutions Part 2: Music Streaming Service | Kevin Rassner",
  metaDescription: "Part 2 of the series on organizational solutions: Analyzing a music streaming service and how its unique circumstances demand specific organizational design.",
  language: "en",
  linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7306203158362341376",
  isLinkedInPost: true,
  tags: ["OrganizationalDesign", "Leadership", "BusinessStrategy"],
});

registerBlogPost({
  slug: "one-size-fits-all-organizational-design",
  author: "Kevin Rassner",
  title: "One size fits all? Not when it comes to organizational design",
  date: "2025-03-11",
  excerpt: "One size fits all? Not when it comes to organizational design. I'm excited to launch a series where we dive deep into how individual company circumstances demand unique organizational solutions.",
  metaTitle: "One Size Fits All in Organizational Design? | Kevin Rassner",
  metaDescription: "Launching a series on why 'one size fits all' fails in organizational design. Exploring how individual company circumstances demand unique solutions.",
  language: "en",
  linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7305131638374449153",
  isLinkedInPost: true,
  tags: ["OrganizationalDesign", "Leadership", "BusinessStrategy", "CompanyCulture"],
});

registerBlogPost({
  slug: "mission-accomplished-13-monate-training-dunk",
  author: "Kevin Rassner",
  title: "Mission accomplished: 13 Monate Training – und mit 37 Jahren wieder ein Dunk!",
  date: "2025-02-02",
  excerpt: "Mission accomplished: 13 Monate Training – und mit 37 Jahren wieder ein Dunk! Gestern, beim Auswärtsspiel gegen die Heilbronn Reds, habe ich endlich das Ziel erreicht, das ich mir Anfang 2024 gesetzt hatte.",
  metaTitle: "Mission Accomplished: Mit 37 Jahren wieder ein Dunk | Kevin Rassner",
  metaDescription: "Nach 13 Monaten Training: Mit 37 Jahren wieder dunken. Ein persönlicher Bericht über Zielsetzung, Training und den Erfolg beim Spiel gegen die Heilbronn Reds.",
  language: "de",
  linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7291785920268161025",
  image: "/assets/blog/mission-accomplished-13-monate-training-dunk.jpg",
  isLinkedInPost: true,
});

registerBlogPost({
  slug: "joined-bosch-business-innovations",
  title: "Half a year ago, I joined Bosch Business Innovations",
  date: "2024-11-18",
  excerpt: "Half a year ago, I joined Bosch Business Innovations with a clear goal: to challenge myself, learn new things, and ultimately apply my skills in new contexts. It's been an incredible journey so far.",
  metaTitle: "Half a Year at Bosch Business Innovations | Kevin Rassner",
  metaDescription: "Reflecting on six months at Bosch Business Innovations: Learning, experimentation, and growth. Insights on social density, joint language, and psychological safety.",
  language: "en",
  linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7264212317947498496",
  isLinkedInPost: true,
  tags: ["StartUpJourney", "GrowthMindset", "BusinessExperiments"],
});

registerBlogPost({
  slug: "rap-und-psychische-konstitution",
  title: "Ich bin wahrlich kein Musikexperte - Rap und psychische Konstitution",
  date: "2024-01-29",
  excerpt: "Ich bin wahrlich kein Musikexperte aber mir ist etwas aufgefallen, das ich gerne mit anderen teilen möchte: Sich kritisch mit 'der eigenen psychischen Konstitution und deren Auswirkungen auf das Umfeld' auseinandersetzen und Rap gehen nicht soooo häufig Hand-in-Hand.",
  metaTitle: "Rap und psychische Konstitution: Ein neuer Trend? | Kevin Rassner",
  metaDescription: "Beobachtungen zur Entwicklung im Deutschrap: Wie Künstler wie Juse Ju und Badmómzjay psychische Gesundheit thematisieren und was das für unsere Gesellschaft bedeutet.",
  language: "de",
  linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7157671852293656576",
  image: "/assets/blog/rap-und-psychische-konstitution.jpg",
  isLinkedInPost: true,
});

registerBlogPost({
  slug: "50-kindergaerten-klettergerueste",
  title: "Ich habe 50 Kindergärten mit Klettergerüsten ausgestattet",
  date: "2024-01-13",
  excerpt: "Ich habe 50 Kindergärten mit Klettergerüsten ausgestattet ☺️ Ich habe die komplette Rechnung übernommen - ca 350k€), weil ich etwas zurückgeben möchte von dem was ich als Bürger Deutschlands ständig an Infrastruktur, Angeboten und Unterstützungen erfahren habe.",
  metaTitle: "50 Kindergärten mit Klettergerüsten ausgestattet | Kevin Rassner",
  metaDescription: "Warum ich 350k€ Steuern zahle und stolz darauf bin: Ein Plädoyer dafür, Steuern als Beitrag zur Gesellschaft zu sehen und 'Giving Back' wieder sexy zu machen.",
  language: "de",
  linkedinUrl: "https://www.linkedin.com/feed/update/urn:li:activity:7152023830352318465",
  isLinkedInPost: true,
});

registerBlogPost({
  slug: "ueberraschung-erfolgreichsten-ceos-operative-tiefe",
  author: "Kevin Rassner",
  title: "Die Überraschung der erfolgreichsten CEOs: Operative Tiefe schlägt strategische Distanz",
  date: "2025-12-02",
  excerpt: "Ein radikaler Umbruch in der Leadership-Forschung: Die erfolgreichsten CEOs von Amazon, Danaher, RELX und Toyota widersprechen konventioneller Weisheit und prägen Systemarchitektur durch operative Teilhabe. Scott Cook und Nitin Nohria zeigen in der Harvard Business Review (November 2025), warum Tiefe in der Ausführung die wahre Quelle von Wettbewerbsvorteilen ist.",
  metaTitle: "Die Überraschung der erfolgreichsten CEOs: Operative Tiefe schlägt strategische Distanz",
  metaDescription: "Ein radikaler Umbruch in der Leadership-Forschung: Die erfolgreichsten CEOs von Amazon, Danaher, RELX und Toyota widersprechen konventioneller Weisheit und prägen Systemarchitektur durch operative Teilhabe. Scott Cook und Nitin Nohria zeigen in der Harvard Business Review (November 2025), warum Tiefe in der Ausführung die wahre Quelle von Wettbewerbsvorteilen ist.",
  language: "de",
});

registerBlogPost({
  slug: "lewins-3-phasen-modell-kritik-moderne-change",
  title: "Lewins 3-Phasen-Modell unter Beschuss: Warum Change heute keine linearen Phasen mehr kennt",
  date: "2025-12-03",
  excerpt: "Klassische Change-Modelle wie Kurt Lewins 3-Phasen-Modell (Unfreeze–Change–Refreeze) geraten zunehmend in die Kritik, weil sie Veränderungen als lineare Phasen beschreiben. Moderne Ansätze kombinieren Lewin mit agilen Schleifen für kontinuierliche Anpassung statt finalem „Einfrieren\".",
  metaTitle: "Lewins 3-Phasen-Modell unter Beschuss: Warum Change heute keine linearen Phasen mehr kennt",
  metaDescription: "Klassische Change-Modelle wie Kurt Lewins 3-Phasen-Modell (Unfreeze–Change–Refreeze) geraten zunehmend in die Kritik, weil sie Veränderungen als lineare Phasen beschreiben. Moderne Ansätze kombinieren Lewin mit agilen Schleifen für kontinuierliche Anpassung statt finalem „Einfrieren\".",
  language: "de",
});

registerBlogPost({
  slug: "ai-organisationskultur-agent-forschung",
  title: "AI als Organisationskultur-Agent: Neue Forschung verändert das OD-Verständnis",
  date: "2025-12-04",
  excerpt: "AI ist nicht nur ein Produktivitäts-Tool, sondern eine kulturelle Kraft, die Vertrauen, psychologische Kontrakte und Teamdynamiken fundamental verändert. Neue Forschung offenbart ein Paradox: Personalisierung steigt, Job-Sicherheit und Vertrauen sinken durch intransparente Algorithmen.",
  metaTitle: "AI als Organisationskultur-Agent: Neue Forschung verändert das OD-Verständnis",
  metaDescription: "AI ist nicht nur ein Produktivitäts-Tool, sondern eine kulturelle Kraft, die Vertrauen, psychologische Kontrakte und Teamdynamiken fundamental verändert. Neue Forschung offenbart ein Paradox: Personalisierung steigt, Job-Sicherheit und Vertrauen sinken durch intransparente Algorithmen.",
  language: "de",
});

registerBlogPost({
  slug: "the-hard-truth-feelings-ideals-relationships-real-hard-stuff-at-work",
  title: "The Hard Truth: Feelings, Ideals, and Relationships Are the Real \"Hard Stuff\" at Work",
  date: "2025-12-04",
  excerpt: "We've been told \"facing reality\" at work means suppressing feelings, ideals, and relationships as soft luxuries. Block and Koestenbaum reveal the opposite: embracing whole humans with their emotions and visions is the truly demanding path to real performance.",
  metaTitle: "The Hard Truth: Feelings, Ideals, and Relationships Are the Real \"Hard Stuff\" at Work",
  metaDescription: "We've been told \"facing reality\" at work means suppressing feelings, ideals, and relationships as soft luxuries. Block and Koestenbaum reveal the opposite: embracing whole humans with their emotions and visions is the truly demanding path to real performance.",
  language: "en",
});

registerBlogPost({
  slug: "psychological-safety-ai-transformation-critical-factor",
  title: "Psychologische Sicherheit als Schlüssel zu erfolgreicher AI-Integration in Organisationen",
  date: "2025-12-11",
  excerpt: "Während 71% der HR-Leader bereits AI-Tools zur Leistungsanalyse nutzen, zeigen Fallstudien: AI-Transformationen scheitern ohne psychologische Sicherheit. Neue Forschung offenbart, warum Teams mit hoher psychologischer Sicherheit AI 3x schneller akzeptieren.",
  metaTitle: "Psychologische Sicherheit als Schlüssel zu erfolgreicher AI-Integration in Organisationen",
  metaDescription: "Während 71% der HR-Leader bereits AI-Tools zur Leistungsanalyse nutzen, zeigen Fallstudien: AI-Transformationen scheitern ohne psychologische Sicherheit. Neue Forschung offenbart, warum Teams mit hoher psychologischer Sicherheit AI 3x schneller akzeptieren.",
  language: "de",
});

registerBlogPost({
  slug: "is-strategie-dreieck-ai-souveraenitaet",
  title: "Das IS-Strategie-Dreieck 2025: Warum AI Agents und Souveränität alles ändern",
  date: "2025-12-16",
  excerpt: "Das klassische Information Systems Strategy Triangle kollabiert unter dem Druck von Agentic AI und europäischen Souveränitätsanforderungen. Dieser Artikel analysiert, wie 'Vibe Coding' die Umsetzungsgeschwindigkeit revolutioniert, während regulatorische Leitplanken zur harten Architekturbedingung werden. Unternehmen müssen ihre IT-Strategie von 'Build' auf 'Guide' umstellen und Compliance als Produktfeature begreifen.",
  metaTitle: "IS-Strategie-Dreieck 2025: AI Agents & Souveränität",
  metaDescription: "Analyse des Information Systems Strategy Triangle im Kontext von AI Agents, Vibe Coding und digitaler Souveränität. Neue Rahmenbedingungen für Organisationen.",
  language: "de",
  tags: ["Systemic Organizational Development", "AI Strategy", "Digital Sovereignty", "Information Systems"],
});

registerBlogPost({
  slug: "kultur-transformation-design-thinking",
  title: "Kultur statt Prozess: Warum echte Transformation mit Design Thinking beginnt",
  date: "2025-12-18",
  excerpt: "Phil Gilberts neues Buch 'Irresistible Change' offenbart die Lernstücke aus einer der größten Unternehmenstransformationen: IBMs Umwandlung von 400.000 Mitarbeitenden. Der zentrale Insight: Echte Veränderung ist kein Prozess-Problem, sondern ein Kultur-Problem. Transformation erfolgt nicht durch Mandate, sondern durch Momentum, verdient durch Ergebnisse, tiefes Zuhören und systemische Integration.",
  metaTitle: "Systemische Kulturveränderung: Der neue IBM-Ansatz zur Transformation (58 chars)",
  metaDescription: "Phil Gilberts revolutionäres Framework zeigt, wie echte Organisationstransformation durch die Kombination von Kultur, Design und dezentralisierter Führung gelingt. (162 chars)",
  language: "de",
  tags: ["Organizational Change", "Cultural Transformation", "Leadership", "Design Thinking", "Systemic Change"],
});

registerBlogPost({
  slug: "sovereign-infrastructure-as-code-startups",
  title: "Sovereign Infrastructure as Code: Der Schutzschild für AI-Startups",
  date: "2025-12-23",
  excerpt: "Infrastructure as Code (IaC) ist mehr als ein Dev-Tool – es ist der strategische Schlüssel zur Auflösung des Konflikts zwischen Agilität und Souveränität. Dieser Artikel zeigt, wie Startups durch modularisierte 'Sovereign Stacks' Compliance-Anforderungen automatisieren ('Policy as Code') und so 'Enterprise-Ready' werden, ohne an Geschwindigkeit zu verlieren. Ein Fokus liegt auf der Portabilität von Stacks als Exit-Strategie.",
  metaTitle: "Sovereign IaC: Schutzschild für AI-Startups & Incubators",
  metaDescription: "Wie Infrastructure as Code (IaC) das Spannungsfeld zwischen Hyper-Agilität und digitaler Souveränität löst. Ein Blueprint für Incubators und Startups.",
  language: "de",
  tags: ["Infrastructure as Code", "Platform Engineering", "Digital Sovereignty", "Startup Operations"],
});

registerBlogPost({
  slug: "lapple-automotive-fuehrungskultur-transformation-hierarchie-coaching",
  title: "Die radikale Transformation von Läpple Automotive: Wie ein Mittelständler Führungskultur grundlegend neu erfand",
  date: "2025-12-24",
  excerpt: "Läpple Automotive, Heilbronner Familienunternehmen, tat das Ungewöhnliche: Es ersetzte gezielt alte Führungskräfte durch jüngere, externe Kandidaten. Nicht aus Kostengründen, sondern weil die Unternehmenskultur einen radikal anderen Führungsstil brauchte. Die Fraunhofer-Studie zeigt, warum dieses Vorgehen funktioniert – und welche anderen Organisationen es nachmachen sollten.",
  metaTitle: "Die radikale Transformation von Läpple Automotive: Wie ein Mittelständler Führungskultur grundlegend neu erfand",
  metaDescription: "Läpple Automotive, Heilbronner Familienunternehmen, tat das Ungewöhnliche: Es ersetzte gezielt alte Führungskräfte durch jüngere, externe Kandidaten. Nicht aus Kostengründen, sondern weil die Unternehmenskultur einen radikal anderen Führungsstil brauchte. Die Fraunhofer-Studie zeigt, warum dieses Vorgehen funktioniert – und welche anderen Organisationen es nachmachen sollten.",
  language: "de",
});

registerBlogPost({
  slug: "fluktuation-transformation-fraunhofer-personalaustausch-erfolgsfaktor",
  title: "Fluktuation als Transformations-Beschleuniger: Was die Fraunhofer-Studie über Personalwechsel enthüllt",
  date: "2025-12-25",
  excerpt: "Die Fraunhofer-Studie widerlegt ein hartnäckiges Dogma: Geringe Fluktuation ist nicht immer besser. Moderate, strategische Fluktuation beschleunigt Innovationszyklen, bringt neue Perspektiven und verhindert Lock-in-Effekte. Die operative Realität ist komplexer als HR-Manager oft denken.",
  metaTitle: "Fluktuation als Transformations-Beschleuniger: Was die Fraunhofer-Studie über Personalwechsel enthüllt",
  metaDescription: "Die Fraunhofer-Studie widerlegt ein hartnäckiges Dogma: Geringe Fluktuation ist nicht immer besser. Moderate, strategische Fluktuation beschleunigt Innovationszyklen, bringt neue Perspektiven und verhindert Lock-in-Effekte. Die operative Realität ist komplexer als HR-Manager oft denken.",
  language: "de",
});

registerBlogPost({
  slug: "hypothesis-engineering-design-to-code",
  title: "Hypothesis Engineering: Wie Design und AI die Infrastruktur steuern",
  date: "2025-12-30",
  excerpt: "Die größte Hürde für 'Sovereign Stacks' ist oft die User Experience. Dieser Artikel schließt die Lücke zwischen Hypothesen-Testung (Figma) und harter Compliance. Er beschreibt, wie 'Design Tokens' als Brücke dienen, um US-Tools sicher zu nutzen, und wie 'AI Concierges' komplexe Infrastruktur für nicht-technische Gründer zugänglich machen. Zudem wird das Problem der 'Platform Updates' durch AI-Migration-Agents gelöst.",
  metaTitle: "Hypothesis Engineering: Von Figma zu Code ohne Lock-in",
  metaDescription: "Wie Startups US-Tools wie Figma nutzen, ohne ihre Souveränität zu opfern. Der Weg vom Design Token zum souveränen Code und Interfaces für Non-Tech-Gründer.",
  language: "de",
  tags: ["DesignOps", "Platform Engineering", "Vibe Coding", "Startup UX"],
});

registerBlogPost({
  slug: "risiken-und-nebenwirkungen-von-ai",
  title: "Risiken und Nebenwirkungen von AI",
  date: "2026-01-02",
  excerpt: "Eine kurze Anekdote über die Beschleunigung durch AI bei der Produktentwicklung und die Risiken durch unvollständige Marktrecherche. Wie Expertier1 in 4 Tagen entstand.",
  metaTitle: "Risiken und Nebenwirkungen von AI: Beschleuniger und Risiko zugleich",
  metaDescription: "Wie AI die Entwicklung von Expertier1 beschleunigte, aber bei der Marktrecherche wichtige Konkurrenten übersah. Eine Lektion in Demut und Geschwindigkeit.",
  language: "de",
  linkedinUrl: "https://www.linkedin.com/posts/kevin-rassner_risiken-und-nebenwirkungen-von-ai-eine-activity-7412512731431620608-X4-A?utm_source=share&utm_medium=member_desktop&rcm=ACoAABOVTMUBYXTIxIvCDnvaQZ6lrRF9KkXF3WM",
  isLinkedInPost: true,
  tags: ["AI", "Startup", "Freelancer", "Marktrecherche", "Expertier1"],
});

registerBlogPost({
  slug: "humanocracy-automation-organizational-development",
  title: "Humanocracy by Code: Warum Automatisierung der Schlüssel zur Menschlichkeit ist",
  date: "2026-01-06",
  excerpt: "Der finale Artikel der Serie widmet sich einem scheinbaren Paradoxon: Kann eine Organisation, die auf Code basiert, menschlich sein? Die Antwort liegt in der 'Nicht-Endgültigkeit'. Indem wir Regeln explizit codieren, machen wir sie angreifbar und verbesserbar. Wir zeigen, wie Retrospektiven und Vibe Coding es Teams ermöglichen, das System selbst umzuschreiben, statt an starrer Bürokratie zu verzweifeln.",
  metaTitle: "Humanocracy by Code: Menschlichkeit durch Automatisierung",
  metaDescription: "Warum Technokratie nicht seelenlos sein muss. Wie 'Organization as Code' administrative Lasten entfernt und Prozesse durch Vibe Coding demokratisch veränderbar macht.",
  language: "de",
  tags: ["Humanocracy", "New Work", "Continuous Improvement", "Psychological Safety"],
});

registerBlogPost({
  slug: "forte-modell-fraunhofer-transformationsindex-31-erfolgsfaktoren",
  title: "Das FORTE-Modell: Wie die Fraunhofer-Studie 250.000 Publikationen in 31 Erfolgsfaktoren übersetzt",
  date: "2026-01-07",
  excerpt: "Mit dem Fraunhofer-Transformationsindex haben Forscher eine einzigartige Metastudie vollendet: 250.000 wissenschaftliche Publikationen systematisch ausgewertet, um die 31 kritischen Erfolgsfaktoren für Transformationen zu isolieren. Das Ergebnis ist das FORTE-Modell – ein Diagnoseinstrument, das zeigt, wo Organisationen wirklich handeln müssen.",
  metaTitle: "Das FORTE-Modell: Wie die Fraunhofer-Studie 250.000 Publikationen in 31 Erfolgsfaktoren übersetzt",
  metaDescription: "Mit dem [Fraunhofer-Transformationsindex](https://www.hnfiz.fraunhofer.de/de/leistungsspektrum/transformationsfaehigkeit/Transformationsindex.html) haben Forscher eine einzigartige Metastudie vollendet: 250.000 wissenschaftliche Publikationen systematisch ausgewertet, um die 31 kritischen Erfolgsfaktoren für Transformationen zu isolieren. Das Ergebnis ist das FORTE-Modell – ein Diagnoseinstrument, das zeigt, wo Organisationen wirklich handeln müssen.",
  language: "de",
});

registerBlogPost({
  slug: "authenticity-at-work-engagement-crisis",
  author: "Kevin Rassner",
  title: "Die unsichtbare Krise: Warum authentische Menschen bessere Mitarbeiter sind - und unsere Systeme das nicht unterstützen",
  date: "2026-01-08",
  excerpt: "Engagement-Zahlen von 32% (USA) und 21% (global) dominieren die Diskussion, doch sie sind irreführend. Der wahre Grund für den Unterschied: Remote-Worker sind engagierter, weil sie authentisch sein können. Wir müssen Systeme bauen, in denen echte Menschen überall gedeihen können.",
  metaTitle: "Authentizität bei der Arbeit: Das eigentliche Engagement-Problem (55 chars)",
  metaDescription: "Remote-Worker zeigen es: Menschen sind produktiver, wenn sie echt sein können. Das Problem ist nicht Engagement. Das Problem ist, dass Systeme Authentizität sanktionieren. (161 chars)",
  language: "de",
  tags: ["Authenticity", "Organizational Culture", "Employee Engagement", "Human-Centered Work", "Leadership"],
});

registerBlogPost({
  slug: "digitale-zwillinge-transformation-schunk",
  title: "Technologie, die Transformation wirklich trägt: Digitale Zwillinge bei Schunk als Blueprint",
  date: "2026-01-13",
  excerpt: "Die Fraunhofer-Studie identifiziert „passende technologische Lösungen\" als eine von fünf Kern-Dimensionen erfolgreicher Transformation. Der Einsatz digitaler Zwillinge beim Maschinenbauer Schunk zeigt, wie Technologie vom Pilotprojekt zum skalierbaren Transformationsmotor wird.",
  metaTitle: "Technologie, die Transformation wirklich trägt: Digitale Zwillinge bei Schunk als Blueprint",
  metaDescription: "Die Fraunhofer-Studie identifiziert „passende technologische Lösungen\" als eine von fünf Kern-Dimensionen erfolgreicher Transformation. Der Einsatz digitaler Zwillinge beim Maschinenbauer Schunk zeigt, wie Technologie vom Pilotprojekt zum skalierbaren Transformationsmotor wird.",
  language: "de",
});

registerBlogPost({
  slug: "psychologische-sicherheit-paradoxon-performance",
  title: "Das Sicherheitsparadoxon: Warum psychologische Sicherheit bei Routineaufgaben die Leistung senken kann",
  date: "2026-01-18",
  excerpt: "Neue Forschungsergebnisse sorgen in der L&D-Community für Aufsehen: Psychologische Sicherheit ist nicht immer positiv. Ab einem bestimmten Punkt kann ein Übermaß an Sicherheit dazu führen, dass Teams bei Routineaufgaben nachlässig werden, Grenzen verwischen und Verantwortung abgeben. Das optimale Modell kombiniert psychologische Sicherheit mit kollektiver Verantwortlichkeit.",
  metaTitle: "Psychologische Sicherheit: Wann Schutz zur Bequemlichkeit wird (Forschung 2025)",
  metaDescription: "Neue Studien zeigen: Zu viel psychologische Sicherheit kann die Performance bei Routineaufgaben sabotieren. Das optimale Balance-Modell.",
  language: "de",
  tags: ["Psychologische Sicherheit", "Team-Performance", "Accountability", "Forschung"],
});

registerBlogPost({
  slug: "das-beste-an-euren-startups-ist-dass-sie-sterben-koennten",
  title: "Das Beste an euren Startups ist, dass sie sterben könnten",
  date: "2026-01-20",
  excerpt: "Startups leben mit der ständigen Möglichkeit des Scheiterns – und gewinnen daraus eine radikale Präsenz, Klarheit und Verantwortungsbereitschaft, die etablierten Organisationen oft fehlt. Der Text überträgt Peter Koestenbaums existentielle Perspektive auf individuelle Arbeit und Organisationsentwicklung und zeigt, warum die Anerkennung unserer eigenen und organisationalen Endlichkeit eine Quelle für Freiheit, Fokus und echte Verantwortung ist.",
  metaTitle: "Warum die Sterblichkeit von Startups ihr größter Vorteil ist",
  metaDescription: "Startups sind existenziell bedroht – und genau das macht sie lebendig, fokussiert und wahrhaftig. Eine Einladung, Arbeit radikal anders zu betrachten.",
  language: "de",
  tags: ["Startups", "Organisationsentwicklung", "Existenzphilosophie", "Führung", "Verantwortung"],
});

registerBlogPost({
  slug: "conscious-unbossing-gen-z-leadership-neu",
  title: "Conscious Unbossing: Warum Gen Z die Chefrolle ablehnt – und was das für Führung bedeutet",
  date: "2026-01-22",
  excerpt: "Neue Daten sorgen für Aufsehen: Gen Z ist 1,7-mal wahrscheinlicher als andere Generationen, bewusst auf Führungsrollen zu verzichten – nicht aus fehlendem Ehrgeiz, sondern aus Ablehnung des klassischen Boss-Modells. Parallel gewinnt «Conscious Unbossing» an Bedeutung – ein Führungsverständnis, das Verantwortung neu interpretiert, ohne sie zu vermeiden.",
  metaTitle: "Conscious Unbossing: Gen Z lehnt traditionelle Führung ab – Interview + Forschung",
  metaDescription: "80% der HR-Profis sind unsicher bei der Nachfolgeplanung. Gen Z sagt Nein zum klassischen Management. Das neue Führungsmodell im Überblick.",
  language: "de",
  tags: ["Führung", "Gen Z", "Generationswechsel", "Leadership Transformation"],
});

registerBlogPost({
  slug: "executive-burnout-kognitive-architektur",
  title: "Die kognitive Überlastung von Führungskräften: Warum „mehr Zeitmanagement“ nicht die Lösung ist",
  date: "2026-01-27",
  excerpt: "Eine schockierende Statistik: 70% der C-Suite-Führungskräfte erwägen den Ausstieg, um ihre Gesundheit zu schützen. Doch klassische Wellness-Ansätze (Meditation, Coaching, Zeitmanagement) greifen zu kurz. Sie ignorieren das Kernproblem: Das neurologische Mismatch zwischen modernen Führungsanforderungen und unserer kognitiven Architektur.",
  metaTitle: "Executive Burnout: Das neurologische Problem hinter Decision Fatigue bei Führungskräften",
  metaDescription: "70% der C-Suite sind überlastet. Das ist kein Wellness-Problem, sondern ein neurologisches Architektur-Problem. Die strukturelle Lösung.",
  language: "de",
  tags: ["Executive Leadership", "Burnout", "Neuroscience", "Decision Making"],
});

registerBlogPost({
  slug: "messen-statt-vorschreiben-arbeitsschutz",
  title: "Messen statt Vorschreiben: Würdevoller Arbeitsschutz neu gedacht",
  date: "2026-01-28",
  excerpt: "Deutschlands Stärke: Menschen verdienen Würde bei der Arbeit. Aber Regulierungen blockieren Innovation. Könnten wir messen statt vorschreiben?",
  metaTitle: "Messen statt Vorschreiben: Arbeitnehmerschutz 2.0",
  metaDescription: "Statt starrer Regeln: Outcome-basierter Arbeitsschutz. Wenn Mitsprache nachweisbar ist, warum dieselben Vorschriften?",
  language: "de",
  tags: ["Arbeitnehmerschutz", "Mitbestimmung", "Organisationsentwicklung"],
});

registerBlogPost({
  slug: "piscine-42-heilbronn-peer-learning-organisationsentwicklung",
  title: "Die Piscine der 42 Heilbronn: Wie Peer-Learning Organisationsentwicklung vorlebt",
  date: "2026-01-29",
  excerpt: "Du hast keine Ahnung, wie man programmiert. Du bekommst Aufgaben. Und du lernst mit Peers. Wie die Piscine der 42 ein Labor für Organisationsentwicklung ist.",
  metaTitle: "Piscine 42 Heilbronn: Peer-Learning als Organisationsentwicklung",
  metaDescription: "Keine Lehrer, keine Vorlesungen, nur Projekte und Peer-Evaluation. Wie die Piscine-Methode Selbstorganisation, psychologische Sicherheit und echtes Lernen kombiniert.",
  language: "de",
  tags: ["Peer Learning", "Selbstorganisation", "Erwachsenenbildung", "Organisationsentwicklung", "Bildungsinnovation"],
});

registerBlogPost({
  slug: "die-harte-wahrheit-gefuehle-ideale-beziehungen-sind-die-echte-arbeit",
  title: "Die harte Wahrheit: Gefühle, Ideale und Beziehungen sind die echte \"harte Arbeit\"",
  date: "2026-01-30",
  excerpt: "Uns wurde beigebracht, dass \"Realismus\" bei der Arbeit bedeutet, Gefühle, Ideale und Beziehungen als weichen Luxus zu unterdrücken. Block und Koestenbaum zeigen das Gegenteil: Den ganzen Menschen mit seinen Emotionen und Visionen anzunehmen, ist der wahre, anspruchsvolle Weg zu echter Leistung.",
  metaTitle: "Die harte Wahrheit: Gefühle, Ideale und Beziehungen sind die echte Arbeit",
  metaDescription: "Uns wurde beigebracht, dass \"Realismus\" bei der Arbeit bedeutet, Gefühle, Ideale und Beziehungen als weichen Luxus zu unterdrücken. Block und Koestenbaum zeigen das Gegenteil: Den ganzen Menschen mit seinen Emotionen und Visionen anzunehmen, ist der wahre, anspruchsvolle Weg zu echter Leistung.",
  language: "de",
});

registerBlogPost({
  slug: "rollen-verhandlung-partnerschaft-arbeit",
  title: "Warum Partnerschaften Rollen verhandeln und Arbeitsteams nicht: Was die Arbeitswelt von privaten Beziehungen lernen kann",
  date: "2026-02-03",
  excerpt: "Peter Koestenbaum und Peter Block argumentieren, dass moderne Organisationen Rollen zu häufig auferlegen, anstatt sie mit Menschen auszuhandeln. Ein Vergleich zwischen Partnerschaften und Arbeitsbeziehungen zeigt: Wo Menschen frei verhandeln können, entsteht echte Accountability. Wo Rollen einfach zugewiesen werden, entsteht Entfremdung. Der Artikel untersucht, warum das so ist und was sich konkret ändern müsste.",
  metaTitle: "Rollen verhandeln statt aufzwingen – Was Arbeit von Partnerschaften lernt",
  metaDescription: "Warum Partnerschaften ihre Rollen explorativ aushandeln, während Arbeitsteams sie aufgezwungen bekommen. Und was das über Accountability aussagt.",
  language: "de",
});

registerBlogPost({
  slug: "memento-mori-business-endlichkeit",
  title: "Memento Mori im Business: Warum wir die Endlichkeit fürchten und warum das alles durcheinanderbringt",
  date: "2026-02-04",
  excerpt: "Koestenbaum und Block argumentieren in 'Confronting Our Freedom', dass die meisten Geschäftspraktiken auf einer subtilen Leugnung von Sterblichkeit basieren: Wir erkennen nicht an, dass Firmen sterben, dass Menschen Fehler machen, dass Ressourcen begrenzt sind. Stattdessen trösten wir uns mit beruhigender 'Kommunikation', während wir in Wirklichkeit Entscheidungen vermeiden. Das hat tiefgreifende Auswirkungen auf alles von Projektmanagement bis zur Customer Experience. Ein Gedanke zur Frage, warum sequentielles Arbeiten so unbeliebt ist und was das über unsere Fähigkeit aussagt, Wahrheit zu akzeptieren.",
  metaTitle: "Sterblichkeit im Business: Warum Organisationen ihre Grenzen leugnen",
  metaDescription: "Koestenbaum und Block zeigen: Organisationen fliehen vor der Realität von Endlichkeit, Scheitern und menschlicher Begrenztheit. Das Problem mit sequentieller Arbeit erklärt.",
  language: "de",
});

registerBlogPost({
  slug: "ki-transformation-strukturelle-integration-carlyle",
  title: "KI-Transformation: Von der \"Adoption\" zur strukturellen Integration",
  date: "2026-02-05",
  excerpt: "Die bloße Einführung von 'Copiloten' steigert keine Produktivität. Neue Fallstudien der Carlyle Group und Analysen von McKinsey zeigen: Echte KI-Gewinne entstehen erst, wenn Organisationen ihre Struktur anpassen und 'Human-in-the-Loop'-Netzwerke statt Hierarchien bauen.",
  metaTitle: "KI-Transformation: Warum Tools allein nicht reichen (Carlyle Case)",
  metaDescription: "Analyse der Carlyle Group Case Study: Wie 90% KI-Adoption durch strukturelle Anpassungen und 'AI Champions' erreicht wurden. Insights von McKinsey & MIT.",
  language: "de",
});

registerBlogPost({
  slug: "renaissance-mittleres-management-work-design",
  title: "Die Renaissance der Mitte: Warum wir Work Design neu denken müssen",
  date: "2026-02-10",
  excerpt: "Jahrelang galt das mittlere Management als Bremser. Neue Forschung aus dem MIT Sloan Review und aktuelle Buchveröffentlichungen zeigen nun das Gegenteil: Manager sind die entscheidenden 'Culture Carrier'. Doch um Burnout zu verhindern, müssen wir aufhören, die Menschen zu reparieren ('Fix the worker') und anfangen, die Arbeit zu reparieren ('Fix the work').",
  metaTitle: "Die Renaissance der Mitte: Warum wir Work Design neu denken müssen",
  metaDescription: "Warum 'Resilienz-Trainings' nicht reichen: Neue Erkenntnisse aus dem MIT Sloan Review und das Buch 'Power to the Middle' fordern ein radikales Work-Redesign.",
  language: "de",
});

registerBlogPost({
  slug: "ende-der-dauer-transformation-hbr-2026",
  title: "Schluss mit dem \"Transformations-Theater\": Warum 2026 das Jahr der Stabilität werden muss",
  date: "2026-02-11",
  excerpt: "Die Januar-Ausgabe des Harvard Business Review läutet einen Paradigmenwechsel ein: 'Get Off the Transformation Treadmill'. Führende Strategen wie Darrell Rigby warnen, dass der ständige Reorganisations-Zyklus Organisationen nicht agiler, sondern fragiler macht. Die Lösung liegt nicht im nächsten großen 'Big Bang', sondern im Wechsel zur 'Project-Driven Organization'.",
  metaTitle: "HBR Jan 2026: Warum ständige Transformationen scheitern",
  metaDescription: "Neue HBR-Studie (Jan/Feb 2026): 'Get Off the Transformation Treadmill'. Warum Unternehmen aufhören müssen, sich ständig neu zu erfinden, und wie 'Continuous Adaptation' stattdessen funktioniert.",
  language: "de",
});

registerBlogPost({
  slug: "leadership-alignment-2026-forbes-korn-ferry",
  title: "Leadership 2026: Die große Sinn-Lücke schließen",
  date: "2026-02-12",
  excerpt: "Am 5. Januar veröffentlichten Forbes und Korn Ferry ihre Ausblicke für 2026. Der Tenor ist alarmierend: Es gibt eine wachsende 'Ambition Gap'. Weniger Talente wollen führen. Die Antwort liegt in radikalem 'Leadership Alignment' – weg von abstrakten Zielen, hin zur Frage: 'Wie soll sich Arbeit anfühlen?'",
  metaTitle: "Leadership Trends 2026: Alignment statt Ambition (Forbes & Korn Ferry)",
  metaDescription: "Neue Reports vom 5. Jan 2026: Forbes und Korn Ferry warnen vor dem 'Ambition Gap'. Warum Führungskräfte 2026 nicht mehr 'die Leiter hochwollen' und was das für die OE bedeutet.",
  language: "de",
});

registerBlogPost({
  slug: "nudging-macht-menschen-klein",
  title: "Der blinde Fleck im Kulturwandel: Wenn Nudging Menschen klein macht",
  date: "2026-02-17",
  excerpt: "HBR wirbt für Kulturwandel über gezielte Verhaltensnudges. Doch ohne echte Mitsprache kippt das schnell in Paternalismus. Was moderne Organisationen daraus lernen sollten.",
  metaTitle: "Kulturwandel: Warum Nudging ohne Mitsprache scheitert",
  metaDescription: "HBR setzt auf Verhaltensnudging, Praktiker auf Co-Creation. Warum echter Kulturwandel nur gelingt, wenn Mitarbeitende mitreden – nicht nur folgen.",
  language: "de",
});

registerBlogPost({
  slug: "mckinsey-ai-workforce-transformation-2026",
  title: "McKinsey's 100-Jahr-Pivot: Wenn AI und Organisationsdesign verschmelzen",
  date: "2026-02-19",
  excerpt: "McKinsey zeigt, dass 100 Jahre alte Organisationen sich für die KI-Ära grundlegend neu ausrichten können: 40.000 Menschen + 25.000 KI-Agenten, ein neues Kompetenzprofil und ein radikaler Wandel von Beratung zu Erfolgs-Partnerschaften.",
  metaTitle: "McKinsey neu ausgerichtet: AI Workforce-Modell und ergebnisorientierte Beratung",
  metaDescription: "Bob Sternfels über die 25-Quadrat-Strategie, neue Kompetenzprofile und die Zukunft der Beratung nach 100 Jahren",
  language: "de",
});

registerBlogPost({
  slug: "fuehrung-mensch-ki-urteilskraft",
  title: "Führung im Zeitalter von Mensch und KI: Warum Urteilsvermögen zur Rarität wird",
  date: "2026-02-26",
  excerpt: "2026 führen nicht die Wissendsten, sondern die Urteilsstärksten. Künstliche Intelligenz verändert nicht nur die Arbeit – sie verändert, was Führung bedeutet.",
  metaTitle: "Führung 2026: Einfluss statt Hierarchie, Urteil statt Wissen",
  metaDescription: "DDI, McKinsey und HBR zeichnen das neue Führungsmodell: Mensch-KI-Orchestrierung, Belastbarkeit und das Ende der Befehlskette",
  language: "de",
});

registerBlogPost({
  slug: "vom-werte-poster-zur-operativen-kultur",
  title: "Vom Werte-Poster zur operativen Kultur – Was Unternehmen wirklich verändert",
  date: "2026-03-01",
  excerpt: "Kultur wird zur operativen Infrastruktur: Ein praktisches Beispiel zeigt, wie Teams Werte in Verhalten übersetzen und Stolperfallen sichtbar machen.",
  metaTitle: "Operative Kultur statt Werte-Poster: Praxisbeispiel 2026",
  metaDescription: "Unternehmen übersetzen Werte in beobachtbares Verhalten. So entsteht operative Kultur – mit erprobter Methode und praktischer Umsetzung.",
  language: "de",
});

registerBlogPost({
  slug: "von-command-and-control-zu-co-creation-psychologie-des-wandels",
  title: "Von Command & Control zu Co-Creation – Psychologie des Wandels endlich evidenzbasiert",
  date: "2026-03-03",
  excerpt: "Change gelingt nicht durch Kontrolle, sondern durch Co-Creation. Der IMD-Artikel liefert die wissenschaftliche Bestätigung für das, was viele längst spüren.",
  metaTitle: "Co-Creation statt Command & Control: Change-Psychologie neu gedacht",
  metaDescription: "Warum erfolgreicher Wandel Psychologie braucht – und wie evidenzbasierte Co-Creation alte Change-Muster ablöst.",
  language: "de",
});

registerBlogPost({
  slug: "hr-trends-2026-leadership-luecke",
  title: "HR-Trends 2026: Die Leadership-Lücke, die Veränderung blockiert",
  date: "2026-03-05",
  excerpt: "Externe Turbulenz wächst schneller als interne Change-Kapazität. Der HR-Trendreport zeigt die Leadership-Lücke – und Lösungsansätze.",
  metaTitle: "HR-Trends 2026: Leadership-Kapazität vs. Change-Druck",
  metaDescription: "Veränderungsgeschwindigkeit übersteigt Leadership-Kapazität – wie Organisationen die strukturelle Risikolücke schließen.",
  language: "de",
});

registerBlogPost({
  slug: "hbr-2026-talentmaerkte-projektorganisationen",
  title: "HBR 2026: Wie interne Talentmärkte und Projekt-Organisationen die Zukunft gestalten",
  date: "2026-03-08",
  excerpt: "HBR zeigt: Hybrid-Talentmärkte optimieren Produktivität und Zufriedenheit. Projektgetriebene Organisationen benötigen Portfolio-Governance und Autonomie.",
  metaTitle: "HBR: Talentmärkte & Projekt-Organisationen – Erfolgsfaktoren 2026",
  metaDescription: "HBR-Studie: Hybrid-Talentmärkte steigern Produktivität um 33%, Projekt-Teams brauchen Autonomie. Praxisimplikationen für OE.",
  language: "de",
});

registerBlogPost({
  slug: "elder-rollen-spaete-karriere-strategisches-asset",
  title: "Elder-Rollen in der Organisation: Späte Karriere als strategisches Asset",
  date: "2026-03-10",
  excerpt: "Der MIT Sloan Management Review schlägt vor, späte Karrierephasen als strukturierte 'Elder'-Rollen zu gestalten: Steward (Kontinuität), Ambassador (Netzwerke), Futurist (Trends), Catalyst (Veränderung). Statt Erfahrung abzubauen, nutzen Unternehmen sie als strategisches Asset – besonders relevant in Zeiten massiver Stellenabbaus und Fachkräftemangel.",
  metaTitle: "Elder-Rollen: Späte Karriere als strategisches Asset",
  metaDescription: "MIT Sloan zeigt vier Schlüsselrollen für erfahrene Mitarbeiter: Steward, Ambassador, Futurist, Catalyst. Wie Unternehmen die 'Elder'-Phase gestalten, um Wissen zu sichern und Transformation zu beschleunigen – gerade in Zeiten massiver Stellenabbaus.",
  language: "de",
});

registerBlogPost({
  slug: "sabbaticals-als-organisations-tool-adult-gap-year",
  title: "Sabbaticals als Organisations‑Tool: Warum das „Adult Gap Year“ jetzt in die OE‑Agenda gehört",
  date: "2026-03-15",
  excerpt: "Sabbaticals wandern vom individuellen Sonderfall zum regulären Element moderner Erwerbsbiografien. Der Artikel zeigt, wie diese Entwicklung als Organisations‑ und OE‑Hebel genutzt werden kann: vom Adult‑Gap‑Year‑Trend über HBR‑Forschung bis zu konkreten Designprinzipien für Policies, Nachfolge‑Stresstests und eine neue interne Erzählung weg von Fehlzeit hin zur Investition in Resilienz und Innovation.",
  metaTitle: "Sabbaticals als Organisations-Tool im Adult-Gap-Year-Zeitalter",
  metaDescription: "Warum das Adult Gap Year Mainstream wird – und wie Sabbaticals gezielt für Resilienz, Nachfolge und Innovation in Organisationen genutzt werden.",
  language: "de",
});

registerBlogPost({
  slug: "diskurs-hbr-mit-sloan-mckinsey-gelassenheit-kognitive-stabilitat",
  title: "Diskurs HBR/MIT Sloan/McKinsey: Gelassenheit & kognitive Stabilität",
  date: "2026-03-17",
  excerpt: "Der aktuelle Diskurs aus MIT Sloan und Substack beleuchtet 'Gelassenheit' als schwächste Führungsfähigkeit: Nur 10% der Leader behalten kognitive Stabilität unter Druck. Organisationsdesign muss Gelassenheit fördern, nicht sabotieren.",
  metaTitle: "Gelassenheit: Kognitive Stabilität als Schlüsselkompetenz 2026",
  metaDescription: "Viraler HBR/MIT Sloan-Diskurs zur 'Gelassenheits-Minderheit': Warum Gelassenheit unter Druck die entscheidende Führungsstärke ist. Designhebel für Organisationen gegen Stress-Erosion.",
  language: "de",
});

registerBlogPost({
  slug: "digitale-dexterity-kultur-als-transformationsmotor",
  title: "Digitale Dexterity: Warum Kultur, nicht Technologie, den Wandel treibt",
  date: "2026-03-24",
  excerpt: "Digitale Transformation ist kein IT-Projekt – sie ist ein Kulturprojekt. Neue Forschung des MIT Sloan zeigt, dass digitale Dexterity entsteht, wenn Teams Technologie in ihre tägliche Praxis integrieren – und Führung Kultur als System denkt.",
  metaTitle: "Digitale Dexterity: Kultur als Schlüssel zur Transformation",
  metaDescription: "Neue MIT-Forschung zeigt: Digitale Transformation gelingt nur, wenn Teams Technologie in ihrer Kultur verankern. Warum Kultur wichtiger ist als Tools.",
  language: "de",
});

registerBlogPost({
  slug: "nicht-der-charakter-macht-den-erfolg-sondern-die-erfahrungen",
  title: "Nicht der Charakter macht den Erfolg – sondern die Erfahrungen",
  date: "2026-03-26",
  excerpt: "Boris Glogers These lautet: Selbstdisziplin, Resilienz und Wachstumsdenken sind meist die Folge von Erfolg – nicht seine Ursache. Dieser Artikel nimmt diese These ernst, verbindet sie mit dem Potenzgesetz-Denken aus Veritasiums Video 'You've Likely Been Playing The Game of Life Wrong', persönlicher Erfahrung aus der Piscine der 42 Heilbronn und zieht praktische Konsequenzen: für Unternehmen, Eltern und jeden Einzelnen, der aufgehört hat zu fragen 'Bin ich gut genug?' – und stattdessen fragt: 'Wie baue ich Kontexte, in denen Wirksamkeit wahrscheinlicher wird?'",
  metaTitle: "Erfolg ist kein Charakter – er entsteht durch Erfahrungen",
  metaDescription: "Selbstdisziplin und Resilienz sind Folgen von Erfolg, nicht seine Ursache. Was das für Unternehmen, Eltern und uns selbst bedeutet – und wie man Kontexte baut.",
  language: "de",
});

registerBlogPost({
  slug: "architect-bridger-catalyst-rollen-innovation",
  title: "Architect, Bridger, Catalyst: Drei Rollen für skalierbare Innovation",
  date: "2026-03-29",
  excerpt: "Harvards neue Studie ‚Genius at Scale‘ zeigt: Innovation wächst durch drei ineinandergreifende Rollen. Architect, Bridger und Catalyst bauen Netzwerke, öffnen Systeme und mobilisieren Bewegung – weit über klassische Innovationsprozesse hinaus.",
  metaTitle: "Architect, Bridger, Catalyst: Drei Rollen der Innovation",
  metaDescription: "Harvard-Forschung 2026 zeigt: Skalierbare Innovation braucht drei Rollen – Architect, Bridger, Catalyst. So wirken sie in dynamischen Systemen.",
  language: "de",
});

registerBlogPost({
  slug: "wenn-ki-vertrauen-kostet",
  title: "Wenn KI Vertrauen kostet: Der soziale Preis der Automatisierung",
  date: "2026-03-31",
  excerpt: "Generative KI verändert Kommunikation – und das nicht immer zum Guten. Der Harvard Business Review zeigt, wie glatte KI-Texte das Vertrauen in Teams senken – und wo KI dennoch hilft.",
  metaTitle: "Wenn KI Vertrauen kostet: Der soziale Preis der Automatisierung",
  metaDescription: "Neue HBR-Forschung zeigt: Zu glatte KI-Kommunikation untergräbt Vertrauen. Wie Teams psychologische Sicherheit wahren, wenn Maschinen mitschreiben.",
  language: "de",
});

registerBlogPost({
  slug: "messy-teams-gewinnen",
  title: "Messy Teams gewinnen: Warum Unordnung der Schlüssel ist",
  date: "2026-04-02",
  excerpt: "Das MIT zeigt, dass Teams, die am Anfang Unordnung zulassen, bessere Ergebnisse erzielen. ‚Messy Teams‘ schaffen Raum für Lernen, Fehler und Exploration – das Herz moderner Teamarbeit.",
  metaTitle: "Messy Teams gewinnen: Unordnung als Erfolgsfaktor",
  metaDescription: "MIT-Forschung zeigt: Teams mit unklarem Startpunkt arbeiten innovativer und liefern bessere Ergebnisse. Warum weniger Struktur mehr Leistung bringt.",
  language: "de",
});

registerBlogPost({
  slug: "genius-at-scale-neue-architektur-der-innovation",
  title: "Genius at Scale: Die neue Architektur der Innovation",
  date: "2026-04-05",
  excerpt: "Harvard Business Schools neues Konzept ‚Genius at Scale‘ beschreibt, wie Innovation durch Systemarchitektur, externe Netzwerke und kollektive Mobilisierung skalierbar wird – nicht durch Einzelleistung.",
  metaTitle: "Genius at Scale: Systemische Innovation bei Harvard",
  metaDescription: "Das HBS-Buch ‚Genius at Scale‘ zeigt, wie Architektur, Vernetzung und kollektive Bewegung Innovation skalierbar machen – jenseits heroischer Führung.",
  language: "de",
});

registerBlogPost({
  slug: "dein-gehirn-will-dopamin-dein-herz-will-wirkung",
  title: "Dein Gehirn will Dopamin. Dein Herz will Wirkung",
  date: "2026-04-09",
  excerpt: "In diesem Artikel geht es um die Verbindung von Dopamin-Jagd, Social-Media-Kultur und Vibecoding – und darum, wie wir digitale Systeme so gestalten koennen, dass schnelle Belohnungen echte Wirkung auf andere Menschen erzeugen.",
  metaTitle: "Dein Gehirn will Dopamin. Dein Herz will Wirkung | Fokus auf Outcome",
  metaDescription: "Wie Dopamin-Schleifen, Vibecoding und AI-Produktivitaet funktionieren – und warum wir von Input und Output zu echten Outcomes kommen muessen.",
  language: "de",
});

registerBlogPost({
  slug: "small-ai-organisationsentwicklung-ki-bildung",
  title: "Small AI statt Big Tech: Warum Organisationsentwicklung der eigentliche Hebel für KI in der Bildung ist",
  date: "2026-04-16",
  excerpt: "Ein neuer World-Bank-Beitrag zeigt, warum KI in der Bildung nicht an Technologie scheitert, sondern an Organisationskultur und fehlender Umsetzungskraft. Der Artikel übersetzt dieses Signal in konkrete Konsequenzen für Organisationsentwicklung, Change und Governance.",
  metaTitle: "Small AI statt Big Tech: Warum Organisationsentwicklung der eigentliche Hebel für KI in der Bildung ist",
  metaDescription: "Ein neuer World-Bank-Beitrag zeigt, warum KI in der Bildung nicht an Technologie scheitert, sondern an Organisationskultur und fehlender Umsetzungskraft. Der Artikel übersetzt dieses Signal in konkrete Konsequenzen für Organisationsentwicklung, Change und Governance.",
  language: "de",
});

registerBlogPost({
  slug: "inklusive-fuehrung-organisationswand-fallstudie",
  title: "Inklusive Führung als Treiber von Organisationswandel: Lektionen aus einer aktuellen Fallstudie",
  date: "2026-04-19",
  excerpt: "Eine neue Veröffentlichung rund um Jane Horans Arbeiten zu inklusiver Führung zeigt, wie sich Macht-, Status- und Exklusionsdynamiken systematisch in Change-Prozessen sichtbar machen. Der Artikel zeigt, wie OE‑Praxis daraus konkrete Gestaltungsprinzipien ableiten kann.",
  metaTitle: "Inklusive Führung als Treiber von Organisationswandel: Lektionen aus einer aktuellen Fallstudie",
  metaDescription: "Eine neue Veröffentlichung rund um Jane Horans Arbeiten zu inklusiver Führung zeigt, wie sich Macht-, Status- und Exklusionsdynamiken systematisch in Change-Prozessen sichtbar machen. Der Artikel zeigt, wie OE‑Praxis daraus konkrete Gestaltungsprinzipien ableiten kann.",
  language: "de",
});

registerBlogPost({
  slug: "creating-joy-centric-culture-capodagli",
  title: "Creating a Joy‑Centric Culture: Wie Freude zu einem Performance‑ und Governance‑Hebel wird",
  date: "2026-04-23",
  excerpt: "Mit dem neuen Buch „Creating a Joy‑Centric Culture“ setzt Bill Capodagli Freude, Sinn und Story an die Stelle von Druck, Kontrolle und Effizienzdenken. Der Artikel zeigt, wie sich diese Kulturlogik in konkrete Gestaltungsprinzipien für Organisationsentwicklung übersetzen lässt.",
  metaTitle: "Creating a Joy‑Centric Culture: Wie Freude zu einem Performance‑ und Governance‑Hebel wird",
  metaDescription: "Mit dem neuen Buch „Creating a Joy‑Centric Culture“ setzt Bill Capodagli Freude, Sinn und Story an die Stelle von Druck, Kontrolle und Effizienzdenken. Der Artikel zeigt, wie sich diese Kulturlogik in konkrete Gestaltungsprinzipien für Organisationsentwicklung übersetzen lässt.",
  language: "de",
});

registerBlogPost({
  slug: "high-agency-kulturen-hbr-fuehrung-eigenverantwortung",
  title: "High-Agency-Kulturen aufbauen: Der HBR-Ansatz für mehr Eigenverantwortung in der Führung",
  date: "2026-04-26",
  excerpt: "Die neue HBR-Analyse „How Leaders Can Build a High-Agency Culture\" zeigt, wie Führungskräfte gezielt Kulturen schaffen, in denen Mitarbeitende aktiv gestalten statt passiv ausführen. Drei konkrete Mechanismen machen Agency im Alltag erfahrbar – mit sofort umsetzbaren Implikationen für Meeting-Design und Entscheidungsarchitektur.",
  metaTitle: "High-Agency-Kulturen aufbauen: Der HBR-Ansatz für mehr Eigenverantwortung in der Führung",
  metaDescription: "Die neue HBR-Analyse „How Leaders Can Build a High-Agency Culture\" zeigt, wie Führungskräfte gezielt Kulturen schaffen, in denen Mitarbeitende aktiv gestalten statt passiv ausführen. Drei konkrete Mechanismen machen Agency im Alltag erfahrbar – mit sofort umsetzbaren Implikationen für Meeting-Design und Entscheidungsarchitektur.",
  language: "de",
});
